import { defineMessages } from 'react-intl-next';
export default defineMessages({
  showFullListButtonText: {
    id: 'paginated-picker.async-select.show-full-list-button.show-full-list-button-text',
    defaultMessage: 'Show full list',
    description: 'Initially we show the first few items on the list. Clicking this button will show the full list.'
  }
});